import ArrowRightIcon from './Icons/ArrowRightIcon';
import { useMemo } from 'react';
import BusinessUnitPickerSubmenu from './BusinessUnitPickerSubmenu';
import { useTranslation } from '../../hooks/useNavConfig';
import { MenuPicker, MenuPickerBody } from '../Menu';
import BusinessUnitsDisclaimerInfo from './BusinessUnitsDisclaimerInfo';
import { useIsUngated } from '../../hooks/useIsUngated';
import { BUSINESS_UNITS_RENAME_GATE } from '../../constants/gates';
import { withErrorBoundary } from '../ErrorBoundary';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _BusinessUnitPicker = ({
  currentBusinessUnit,
  businessUnits
}) => {
  const {
    t
  } = useTranslation();
  const displayName = `${currentBusinessUnit.name} ${currentBusinessUnit.id === 0 ? '(Account)' : ''}`;
  const filteredBusinessUnits = useMemo(() => {
    return businessUnits.filter(businessUnit => businessUnit.id !== currentBusinessUnit.id);
  }, [businessUnits, currentBusinessUnit]);
  const isUngatedForBusinessUnitsRebrand = useIsUngated(BUSINESS_UNITS_RENAME_GATE);
  return /*#__PURE__*/_jsxs(MenuPicker, {
    id: "navBusinessUnit-current",
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [t(isUngatedForBusinessUnitsRebrand ? 'nav.tools.businessUnitsPickerTitleV2' : 'nav.tools.businessUnitsPickerTitle'), /*#__PURE__*/_jsx(BusinessUnitsDisclaimerInfo, {})]
    }),
    "aria-label": t(isUngatedForBusinessUnitsRebrand ? 'nav.tools.businessUnitsPickerAriaLabelV2' : 'nav.tools.businessUnitsPickerAriaLabel', {
      businessName: currentBusinessUnit.name
    }),
    "aria-owns": "manageBusinessUnits",
    "aria-controls": "manageBusinessUnits",
    "data-test-id": "nav-account-menu-business-unit-picker",
    submenu: /*#__PURE__*/_jsx(BusinessUnitPickerSubmenu, {
      businessUnits: filteredBusinessUnits
    }),
    children: [/*#__PURE__*/_jsx(MenuPickerBody, {
      name: displayName
    }), /*#__PURE__*/_jsx(ArrowRightIcon, {})]
  });
};
export const BusinessUnitPicker = withErrorBoundary(memoWithDisplayName('BusinessUnitPicker', _BusinessUnitPicker), {
  boundaryName: 'BusinessUnitPicker'
});